/**
 * Database backups (docs/adr/ADR-006): every environment is dumped every night
 * by a Cloud Run Job into a private bucket that deletes files after 30 days.
 * Each run records its outcome, so administrators can read whether backups work.
 */
/** Days a backup file is kept; the bucket lifecycle rule in K-Apps-Platform enforces it. */
export const BACKUP_RETENTION_DAYS = 30;
/** A nightly backup older than this means the schedule did not run or failed. */
export const BACKUP_MAX_AGE_HOURS = 26;
export const BACKUP_TRIGGERS = ['scheduled', 'pre-deploy', 'manual', 'pre-restore'];
export const BACKUP_TRIGGER_LABELS = {
    scheduled: 'Notturno',
    'pre-deploy': 'Prima del rilascio',
    manual: 'Manuale',
    'pre-restore': 'Prima di un ripristino',
};
export function isBackupTrigger(value) {
    return BACKUP_TRIGGERS.includes(value);
}
/** Health of the backups from the recorded runs (any order). */
export function backupHealth(runs, now, maxAgeHours = BACKUP_MAX_AGE_HOURS) {
    // A backup that could not be read back is not a backup (ADR-016).
    const newestFirst = [...runs]
        .map((run) => run.status === 'succeeded' && run.verifyError
        ? { ...run, status: 'failed', error: `Verifica: ${run.verifyError}` }
        : run)
        .sort((a, b) => Date.parse(b.finishedAt) - Date.parse(a.finishedAt));
    const latest = newestFirst[0];
    const lastSuccess = newestFirst.find((run) => run.status === 'succeeded');
    const base = {
        lastSuccessAt: lastSuccess?.finishedAt ?? null,
        lastRunAt: latest?.finishedAt ?? null,
        lastError: latest?.status === 'failed' ? latest.error : null,
    };
    if (!lastSuccess)
        return { state: 'never', ...base };
    const ageHours = (now.getTime() - Date.parse(lastSuccess.finishedAt)) / 3_600_000;
    if (ageHours > maxAgeHours)
        return { state: 'late', ...base };
    if (latest?.status === 'failed')
        return { state: 'failed', ...base };
    return { state: 'ok', ...base };
}
//# sourceMappingURL=backup-contracts.js.map